/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_New_ResumeInputs */

const en_resumes_new_resume = /** @type {(inputs: Resumes_New_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Resume`)
};

const de_resumes_new_resume = /** @type {(inputs: Resumes_New_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Lebenslauf`)
};

const fr_resumes_new_resume = /** @type {(inputs: Resumes_New_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau CV`)
};

const es_resumes_new_resume = /** @type {(inputs: Resumes_New_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo currículum`)
};

const it_resumes_new_resume = /** @type {(inputs: Resumes_New_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo curriculum`)
};

const nl_resumes_new_resume = /** @type {(inputs: Resumes_New_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuw CV`)
};

const pl_resumes_new_resume = /** @type {(inputs: Resumes_New_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowe CV`)
};

const fi_resumes_new_resume = /** @type {(inputs: Resumes_New_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uusi ansioluettelo`)
};

const da_resumes_new_resume = /** @type {(inputs: Resumes_New_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyt CV`)
};

const sv_resumes_new_resume = /** @type {(inputs: Resumes_New_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nytt CV`)
};

/**
* | output |
* | --- |
* | "New Resume" |
*
* @param {Resumes_New_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_new_resume = /** @type {((inputs?: Resumes_New_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_New_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_new_resume(inputs)
	if (locale === "fr") return fr_resumes_new_resume(inputs)
	if (locale === "es") return es_resumes_new_resume(inputs)
	if (locale === "it") return it_resumes_new_resume(inputs)
	if (locale === "nl") return nl_resumes_new_resume(inputs)
	if (locale === "pl") return pl_resumes_new_resume(inputs)
	if (locale === "fi") return fi_resumes_new_resume(inputs)
	if (locale === "da") return da_resumes_new_resume(inputs)
	if (locale === "sv") return sv_resumes_new_resume(inputs)
	return en_resumes_new_resume(inputs)
});